import {
  Box,
  FormControl,
  FormControlProps,
  InputBaseProps,
} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { SxProps } from "@mui/system";
import {
  Controller,
  FieldErrors,
  FieldValues,
  UseControllerProps,
} from "react-hook-form";
import { getError } from "../../../../utils/common";
import styles from "./styles";
import InputErrorText from "../Input/InputErrorText";

type InputProps<T extends FieldValues> = UseControllerProps<T> &
  FormControlProps &
  InputBaseProps & {
    label?: string;
    errors?: FieldErrors;
    maxLength?: number;
    customStyles?: { [key: string]: SxProps };
    additionalInfo?: string;
    view?: boolean;
    icon?: any;
    onEmailChange?: any;
    onCustomChange?: any;
    loading?: boolean;
    placeholder?: string;
    options: any;
    row?: boolean;
  };

const RadioLabelGroup = <T extends FieldValues>({
  name,
  control,
  label,
  type = "text",
  fullWidth = true,
  errors,
  rules,
  customStyles,
  onEmailChange = () => {},
  onCustomChange = () => {},
  placeholder,
  icon,
  maxLength,
  inputProps,
  options,
  variant = "standard",
  className,
  additionalInfo,
  view = false,
  loading = false,
  row = true,
  ...rest
}: InputProps<T>) => {
  const error = getError(name, errors);
  return (
    <Controller
      render={({ field }) => (
        <FormControl
          sx={{ ...customStyles?.input } as SxProps}
          fullWidth={fullWidth}
          variant={variant}
          className={className}
        >
          <Box sx={styles.radioBox}>
            <RadioGroup
              row={row}
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={field.value}
              onChange={(e) => {
                field.onChange(e);
                onCustomChange(e);
              }}
              className="radio_group"
            >
              {options?.map(
                (item: any) =>
                  item.label && (
                    <FormControlLabel
                      key={item.label}
                      className="radio_label"
                      value={item.value}
                      control={<Radio />}
                      label={item.label}
                    />
                  )
              )}
            </RadioGroup>
          </Box>
          {error && (
            <InputErrorText
              error={error?.message}
              sx={{ ml: 0, mt: 1 }}
              disablePopup
            />
          )}
        </FormControl>
      )}
      name={name}
      control={control}
      rules={rules}
      {...rest}
    />
  );
};

export default RadioLabelGroup;
